import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Yönləndirmə üçün useNavigate
import './ElanlarAdmin.css'; // Stil faylını import edirik
import ElanController from '../../../api/elan/ElanController';
import UserController from '../../../api/user/UserController'; // UserController import edirik
import Loader from '../../../components/Loader';
import ElanCard from '../../../components/ElanCard';
import LotoreyaController from '../../../api/lotoreya/LotoreyaController';

const ElanlarAdmin = () => {
  const [selectedCategory, setSelectedCategory] = useState('taxi');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredElans, setFilteredElans] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [usernames, setUsernames] = useState({}); // to store the usernames of users
  const [filterType, setFilterType] = useState('all'); // 'all' | 'normal' | 'premium'
  const [lotoreyaStatuses, setLotoreyaStatuses] = useState({});

  const categories = [
    { name: 'Moto Taksi Elanları', value: 'taxi' },
    { name: 'Moto Alqı-Satqı Elanları', value: 'sales' },
    { name: 'Moto Kirayə Elanları', value: 'rent' },
    { name: 'Moto Zapçast Elanları', value: 'spare' },
  ];
  

  const navigate = useNavigate(); // useNavigate hookunu istifadə edirik

  useEffect(() => {
    const checkLotoreyaStatuses = async () => {
      try {
        const allLotoreyas = await LotoreyaController.getAllLotoreyas();
        const statuses = {};

        allLotoreyas.forEach(lotoreya => {
          if (lotoreya.carx == null) {
            statuses[lotoreya.elanId] = lotoreya.isAccept ? 'accepted' : 'pending';
          } else {
            statuses[lotoreya.elanId] = null; // Lotoreya başa çatıbsa status göstərilmir
          }
        });

        setLotoreyaStatuses(statuses);
      } catch (error) {
        console.error('Lotoreyalar yoxlanarkən xəta:', error);
      }
    };

    checkLotoreyaStatuses();
  }, [filteredElans]);

  useEffect(() => {
    const loadElans = async () => {
      try {
        const response = await ElanController.getAllElans();

        if (response && Array.isArray(response)) {
          const categoryElans = response.filter(elan => elan.category === selectedCategory);

          // Axtarışa görə filtrlemə
          const filteredData = categoryElans.filter(elan =>
            elan.title.toLowerCase().includes(searchQuery.toLowerCase())
          );

          setFilteredElans(filteredData.reverse());

          // İstifadəçiləri yükləyirik
          const usersData = {};
          for (const elan of filteredData) {
            const user = await UserController.getUserById(elan.userId);  // User məlumatlarını çəkirik
            usersData[elan.userId] = user.name;  // Username-ni map-layırıq
          }

          setUsernames(usersData); // Username məlumatlarını saxlayırıq
        } else {
          throw new Error('Serverdən gələn məlumat düzgün formatda deyil');
        }
      } catch (error) {
        console.error('Elanlar yüklənərkən xəta:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadElans();
  }, [selectedCategory, searchQuery]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category); // Kategoriya seçimi dəyişir
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value); // Axtarış sorğusu dəyişir
  };

  const handleUsernameClick = (userId) => {
    navigate(`/private/istifadeciler/${userId}`);
  };

  const handleElanClick = (elanId) => {
    navigate(`/private/elan/${elanId}`);
  };

  const handleBack = () => {
    navigate(-1); // Geri getmək üçün bu funksiyanı istifadə edirik
  };

  return (
    <div className="elan-container">
      <button onClick={handleBack} className="back-button">
        Geri
      </button>

      <div className="category-buttons">
        {categories.map((category) => (
          <button
            key={category.value}
            className={`category-button ${selectedCategory === category.value ? 'active' : ''}`}
            onClick={() => handleCategoryClick(category.value)}
          >
            {category.name}
          </button>
        ))}
      </div>

      <div className="search-section">
        <input
          type="text"
          placeholder="Axtarış"
          className="search-input"
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </div>

      <div className="filter-group">
        <label>
          <input
            type="radio"
            name="filter"
            value="all"
            checked={filterType === 'all'}
            onChange={() => setFilterType('all')}
          />
          Hamısı
        </label>

        <label>
          <input
            type="radio"
            name="filter"
            value="normal"
            checked={filterType === 'normal'}
            onChange={() => setFilterType('normal')}
          />
          Normal
        </label>

        <label>
          <input
            type="radio"
            name="filter"
            value="premium"
            checked={filterType === 'premium'}
            onChange={() => setFilterType('premium')}
          />
          Premium
        </label>
      </div>

      <div className="elans-container">
        {isLoading ? (
          <Loader />
        ) : (
          filteredElans.length === 0 ? (
            <div className="no-elans">Heç bir elan tapılmadı.</div>
          ) : (
            filteredElans
              .filter((elan) => {
                if (filterType === 'premium') return elan.premium === true;
                if (filterType === 'normal') return !elan.premium;
                return true; // 'all' seçilibsə
              })
              .map((elan, index) => (
                <ElanCard
                  key={index}
                  {...elan}
                  title={
                    elan.title.length > 25
                      ? elan.title.slice(0, 25) + '...'
                      : elan.title
                  }
                  description={
                    elan.description.length > 30
                      ? elan.description.slice(0, 30) + '...'
                      : elan.description
                  }
                  onUsernameClick={handleUsernameClick}
                  onClick={() => handleElanClick(elan.id)}
                  lotoreyaStatus={lotoreyaStatuses[elan.id] || null} // 🟢 GÖNDƏRİRİK
                />

              ))

          )
        )}
      </div>
    </div>
  );
};

export default ElanlarAdmin;

